import { render, staticRenderFns } from "./page20.vue?vue&type=template&id=9b03b694&scoped=true&"
import script from "./page20.vue?vue&type=script&lang=js&"
export * from "./page20.vue?vue&type=script&lang=js&"
import style0 from "./page20.vue?vue&type=style&index=0&id=9b03b694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b03b694",
  null
  
)

export default component.exports